define('views/search-hint',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init() {
        document.body.addEventListener("click", function (e) {
            var element = e.target;
            if (element.classList.contains("search-hint")) {
                $("input[type=search]").val(element.innerText).keyup();
            }
        });
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/views/search-hint.js.map;
